import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  IconButton,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import api from "../../../../api/axios";
import { toast } from "react-toastify";

type Props = {
  open: boolean;
  onClose: () => void;
  totalOffers: number;
  onAllDeleted: () => void;
};

const OfferDeleteAllModal: React.FC<Props> = ({
                                                open,
                                                onClose,
                                                totalOffers,
                                                onAllDeleted,
                                              }) => {
  const [loading, setLoading] = useState(false);

  const handleDeleteAll = async () => {
    setLoading(true);

    try {
      await toast.promise(api.post(`/on-sale/remove-all`), {
        pending: "Deleting all offers...",
        success: "All offers removed",
        error: "Delete failed",
      });

      onAllDeleted();
      onClose();
    } finally {
      setLoading(false);
    }
  };

  return (
      <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
        <div className="relative">
          <DialogTitle>Delete All Offers</DialogTitle>
          <IconButton onClick={onClose} className="!absolute right-3 top-3">
            <CloseIcon />
          </IconButton>
        </div>

        <DialogContent>
          Do you really want to delete all {totalOffers} offers?
        </DialogContent>

        <DialogActions>
          <Button onClick={onClose} disabled={loading} className="text-gray-700 dark:text-gray-200">
            Cancel
          </Button>
          <Button
              color="error"
              variant="contained"
              onClick={handleDeleteAll}
              disabled={loading}
          >
            Delete All
          </Button>
        </DialogActions>
      </Dialog>
  );
};

export default OfferDeleteAllModal;
